import {ChipProps, Chip as MuiChip, Stack, styled, Typography} from '@mui/material';
import {filter, find, get} from 'lodash';
import {FC} from 'react';
import {useFilterPredefined} from './useFilterPredefined';
import {filterServiceRequestsBy as filterBy} from './filters.data';
import {IReportFilterValue} from './ReportFilter';

interface Props {
  items: IReportFilterValue[];
  onRemove: (filters: IReportFilterValue[]) => void;
}

const Chip = styled((props: ChipProps) => <MuiChip {...props} />)(() => ({
  backgroundColor: '#FFECCC',
  border: `1px solid #FF9F00`,
  '& .MuiChip-deleteIcon': {
    color: '#2196f3',
  },
  '& .MuiChip-deleteIcon:hover': {
    color: '#03a9f4',
  },
}));

function getLabel(value: IReportFilterValue, predefined: ReturnType<typeof useFilterPredefined>) {
  const deviceTypeCode = get(predefined, 'deviceTypeCode');
  const taskLocationCode = get(predefined, 'taskLocationCode');

  const label = get(value, 'value.label', value.value);
  return get(find(deviceTypeCode, ['1', label]), '0') || get(find(taskLocationCode, ['1', label]), '0') || label;
}

export const ReportFilterItems: FC<Props> = ({onRemove, items = []}) => {
  const predefined = useFilterPredefined();
  const handleRemove = (idx: number) => {
    onRemove(filter(items, (_, i) => i !== idx));
  };

  return (
    <Stack
      minHeight={42}
      direction="row"
      flexWrap="wrap"
      sx={{
        '& > div': {
          margin: '5px',
        },
      }}
    >
      {items.map((filter, i) => (
        <Chip
          key={filter.filterBy}
          variant="outlined"
          label={
            <Stack direction="row" spacing={0.5}>
              <Typography variant="subtitle2" sx={{color: '#818181'}}>
                {get(find(filterBy, ['1', filter.filterBy]), '0')}:
              </Typography>
              <Typography variant="subtitle2">{getLabel(filter, predefined)}</Typography>
            </Stack>
          }
          onDelete={() => handleRemove(i)}
        />
      ))}
    </Stack>
  );
};
